import { getOwsPath } from 'owa-config';
import getScopedPath from 'owa-url/lib/getScopedPath';

export function getStartupDataEndpoint() {
    return getScopedPath(getOwsPath()) + '/startupdata.ashx';
}
